const $ = jQuery.noConflict();

'use strict';
const Video = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domHeader: $('.site-header'),

	/** @description Initialize */
	init: function() {
		this.videoBlock();
	},

	videoBlock: function() {
		// document.querySelectorAll('.video-block__box').forEach(box => {
		// 	const video = box.querySelector('.js-video');
		// 	const muteBtn = box.querySelector('.video-block__box-sound');
		// 	const isTouchDevice = 'ontouchstart' in window;

		// 	if (!isTouchDevice) {
		// 		box.addEventListener('mouseenter', () => {
		// 			video.play();
		// 			box.classList.add('shadow');
		// 		});

		// 		box.addEventListener('mouseleave', () => {
		// 			video.pause();
		// 			box.classList.remove('shadow');
		// 		});
		// 	}

		// 	if (isTouchDevice) {
		// 		box.addEventListener('click', () => {
		// 			if (!muteBtn.contains(event.target)) {
		// 				if (video.paused) {
		// 					video.play();
		// 					box.classList.add('shadow');
		// 				} else {
		// 					video.pause();
		// 					box.classList.remove('shadow');
		// 				}
		// 			}
		// 		});
		// 	}

		// 	muteBtn.addEventListener('click', () => {
		// 		video.muted = !video.muted;

		// 		if (video.muted) {
		// 			muteBtn.classList.remove('is-selected');
		// 		} else {
		// 			muteBtn.classList.add('is-selected');
		// 		}
		// 	});
		// });
		document.querySelectorAll('.video-block__box').forEach(box => {
			const video = box.querySelector('.js-video');
			const muteBtn = box.querySelector('.video-block__box-sound');
			const isTouchDevice = 'ontouchstart' in window;

			if (!isTouchDevice) {
				box.addEventListener('mouseenter', () => {
					video.play();
					box.classList.add('shadow');
				});

				box.addEventListener('mouseleave', () => {
					video.pause();
					box.classList.remove('shadow');
				});
			}

			if (isTouchDevice) {
				box.addEventListener('click', (event) => {
					const _self = box;
					if (muteBtn.contains(event.target)) return;

					if (_self.classList.contains('active')) {
						video.pause();
						box.classList.remove('shadow');
						_self.classList.remove('active');
					} else {
						_self.parentElement.querySelectorAll('.video-block__box').forEach(siblingBox => {
							if (siblingBox !== _self) {
								const siblingVideo = siblingBox.querySelector('.js-video');
								siblingVideo.pause();
								siblingBox.classList.remove('active');
							}
						});

						video.play();
						box.classList.add('shadow');
						_self.classList.add('active');
					}
				});
			}

			muteBtn.addEventListener('click', () => {
				video.muted = !video.muted;

				if (video.muted) {
					muteBtn.classList.remove('is-selected');
				} else {
					muteBtn.classList.add('is-selected');
				}
			});
		});
	},
};

export default Video;